import { Alert, Box, Snackbar, Stack, Typography } from "@mui/material";
import Button from "../../components/Button/Button";
import { LoadingSpinner } from "../../components/shared/LoadingSpinner/LoadingSpinner";
import { UpdateErrorComponent } from "../../components/shared/UpdateErrorComponent/UpdateErrorComponent";
import { LoginFormState } from "../../hooks/Login/useLoginForm";
import { setOpenErrorModal } from "../../Redux/Slices/AppProposalSlice";
import { CardHeading, StyledDialog } from "../../Styles/GlobalStyles";
import {
  StyledLoginErrorButtonStack,
  StyledLoginErrorStack,
  StyledLoginErrorTypography,
} from "./Login";

// The snackbars, loader and popups of /login (Pages/Login/Login.tsx), for the FiberFirst
// login screen.
export const LoginDialogs = ({ login }: { login: LoginFormState }) => {
  const {
    PaymentWarningMessage,
    PaymentWarningMessageData,
    loader,
    openErrorModal,
    lsamError,
    setLsamError,
    openPopup,
    openDetailsRequiredPopup,
    lsamErrorMessage,
    handleForgotPasswordRedirect,
    handleRegisterRedirect,
    accountLinkedSuccessMessage,
    setAccountLinkedSuccessMessage,
  } = login;
  const { vertical, horizontal } = PaymentWarningMessage;

  return (
    <>
      {PaymentWarningMessageData?.homeScreenMessage?.error &&
        PaymentWarningMessageData?.homeScreenMessage?.paymentScreen &&
        PaymentWarningMessage?.message && (
          <Box sx={{ width: 500 }}>
            <Snackbar
              sx={{ textAlign: "center" }}
              anchorOrigin={{ vertical, horizontal }}
              open={true}
              message={PaymentWarningMessage?.message}
              key={vertical + horizontal}
            />
          </Box>
        )}
      {loader && <LoadingSpinner />}
      {openErrorModal && (
        <UpdateErrorComponent openError={openErrorModal} setOpenError={setOpenErrorModal} />
      )}
      {lsamError && <UpdateErrorComponent openError={lsamError} setOpenError={setLsamError} />}
      {openPopup && (
        <>
          <StyledDialog data-testid="usermessage" fullWidth open={openPopup}>
            <CardHeading textAlign={"center"} fontSize={"16px !important"}>
              For enhanced security, please reset your password before logging in.
            </CardHeading>

            <Stack my={1.5}>
              <Stack direction={"row"} gap={"16px"} justifyContent={"center"}>
                <Button
                  title="RESET PASSWORD"
                  type="root"
                  onClick={handleForgotPasswordRedirect}
                />
              </Stack>
            </Stack>
          </StyledDialog>
        </>
      )}

      {openDetailsRequiredPopup && (
        <>
          <StyledDialog data-testid="usermessage" fullWidth open={openDetailsRequiredPopup}>
            <Stack my={1.5}>
              {openDetailsRequiredPopup && (
                <StyledLoginErrorStack padding={"20px"} gap={"1rem"}>
                  <StyledLoginErrorStack>
                    <StyledLoginErrorTypography>
                      {lsamErrorMessage?.map((data: any) => {
                        return (
                          <>
                            <Typography
                              fontWeight={600}
                              sx={{ fontSize: { xs: "12px", sm: "14px" } }}>
                              {data}
                            </Typography>
                          </>
                        );
                      })}
                    </StyledLoginErrorTypography>
                  </StyledLoginErrorStack>
                  <StyledLoginErrorButtonStack direction={"row"}>
                    <Button title="Sign up" type="root" onClick={handleRegisterRedirect} />
                  </StyledLoginErrorButtonStack>
                </StyledLoginErrorStack>
              )}
            </Stack>
          </StyledDialog>
        </>
      )}

      <Snackbar
        open={!!accountLinkedSuccessMessage}
        autoHideDuration={6000}
        onClose={() => setAccountLinkedSuccessMessage("")}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert
          onClose={() => setAccountLinkedSuccessMessage("")}
          severity="success"
          sx={{
            width: "100%",
            backgroundColor: "#2e7d32", // dark green (Material UI's dark success shade)
            color: "#fff", // white text for contrast
            fontWeight: 500,
          }}>
          {accountLinkedSuccessMessage}
        </Alert>
      </Snackbar>
    </>
  );
};
